/**
 * @readonly
 * @constant
 * @enum {string}
 */
export const TaskTypes = {
  /**@default "custom-hoya" */
  HOYA: "custom-hoya",

  /**@default "custom-nagasaka" */
  NAGASAKA: "custom-nagasaka",

  /**@default "forecasting" */
  FORECASTING: "forecasting",

  /**@default "classification" */
  CLASSIFICATION: "classification",

  /**@default "regression" */
  REGRESSION: "regression",

  /**@default "compression" */
  COMPRESSION: "compression",

  /**@default "denoising" */
  DENOISING: "denoising",

  /**@default "object-detection" */
  OBJECT_DETECTION: "object-detection",

  /**@default "auto-quality" */
  AUTO_QUALITY: "auto-quality",

  /**@default "segmentation" */
  SEGMENTATION: "segmentation",
};
